import { IconButton } from "@material-ui/core";
import { ArrowCircleRight } from "@mui/icons-material";
import React, {Component} from "react";
import { useHistory } from "react-router-dom";

import image from "../../assets/images/submodules/school.jpg"

const LocationModule = () => {
    let history = useHistory();

    return   (
        <div className="module module-location" onClick={() => { history.push("/locations")}}>
            <div className="module-picture">
                <img 
                className="logo"
                src={image} 
                alt="School Building"
            />
            </div>
            <div className="module-info-container">
                <div className="module-name">Sites</div>
                <div className="module-description">This module contains the sites associated with the current user.</div>
                <div className="module-go">
                    <IconButton 
                            variant="contained" 
                            color="primary"
                            aria-label={"View all locations" }

                            onClick={() => {
                                history.push("/locations")
                        }}>
                            <ArrowCircleRight style={{fill: "white" }}/>
                    </IconButton>
                </div>
            </div>
        </div>
    )
}

export default LocationModule;
